<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">Feriados</h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select
                  class="select-success mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-success"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div>
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      color="success"
                      clearable
                      prefix-icon="el-icon-search"
                      placeholder="Pesquisar feriado"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
                <div>
                  <base-button
                    type="success"
                    class="animation-on-hover"
                    style="margin: 0px 5px 0px 5px;"
                    @click.native="abrirModal(false)"
                    >Cadastrar Feriado</base-button
                  >
                </div>
              </div>
            </div>
            <el-table :data="queriedData">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="135" align="right" label="Ações">
                <div slot-scope="props">
                  <base-button
                    @click.native="abrirModal(true, props.row)"
                    class="edit btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                  <base-button
                    @click.native="handleDelete(props.$index, props.row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button>

                  <el-tooltip
                    content="Vincular Postos de Trabalho"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click.native="vincularPostos(props.$index, props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-check-2"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="font-weight-normal">
                Mostrando de {{ from + 1 }} a {{ to }} no total de
                {{ total }} feriados.
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="dialogHorarioLimite">
      <template slot="header">
        <h4 class="modal-title" id="exampleModalLabel">
          {{ cadAlt }}
        </h4>
      </template>
      <div class="row">
        <div class="col-md-12 pr-md-1 text-left">
          <base-input
            label="Descrição"
            placeholder="Descrição"
            v-model="modal.descricao"
          >
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 pr-md-1 text-left">
          <base-input
            label="Data"
            type="date"
            placeholder="dia/mês/ano"
            v-model="modal.dataFeriado"
          >
          </base-input>
        </div>
      </div>
      <template slot="footer">
        <div class="w-100 d-flex justify-content-end">
          <base-button type="success" @click="salvarFeriado()"
            >Salvar</base-button
          >
        </div>
      </template>
    </modal>

    <modal :show.sync="showModalFeriado">
      <template slot="header">
        <h4 class="modal-title" id="exampleModalLabel">
          Vincular Postos de Trabalho
        </h4>
      </template>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <el-select
              multiple
              class="select-success pagination-select w-100"
              size="large"
              v-model="postosFeriado"
              collapse-tags
              placeholder="Selecione as opções"
            >
              <el-option
                v-for="option in postos"
                class="select-info"
                :value="option.id"
                :label="option.local"
                :key="option.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <template slot="footer">
        <base-button
          type="danger"
          :disabled="isLoading"
          @click="fecharVincularPostos()"
          >Fechar</base-button
        >
        <base-button
          type="success"
          :disabled="isLoading"
          @click="enviarVincularPostos()"
          >Salvar</base-button
        >
      </template>
    </modal>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Fuse from "fuse.js";
import NotificationHorarioLimite from "./Notifications/NotificationHorarioLimite.vue";
import Modal from "@/components/Modal.vue";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      postos: [],
      postosFeriado: [],
      showModalFeriado: false,
      feriadoSelecionado: "",
      idFuncionarioSelecionado: 0,
      cadAlt: "",
      modal: {
        descricao: "",
        dataFeriado: "",
      },
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      isLoading: false,
      dialogHorarioLimite: false,
      searchQuery: "",
      propsToSearch: ["descricao", "data"],
      tableColumns: [
        {
          prop: "descricao",
          label: "Descrição",
          minWidth: 200,
        },
        {
          prop: "data",
          label: "Data",
          minWidth: 250,
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    };
  },
  mounted() {
    this.listarFeriados();
    this.listarPostos();
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["descricao", "data"],
      threshold: 0.3,
    });
  },
  methods: {
    enviarVincularPostos() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: this.feriadoSelecionado.id,
        empregadores: this.postosFeriado,
      };
      this.axios
        .post("/api/feriado/atualizarFeriadoEmpregador", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.dialogHorarioLimite = false;
          th.fecharVincularPostos();
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Feriado atualizado com sucesso!",
            "success",
          );
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao atualizar feriado!",
            "error",
          );
        });
    },

    fecharVincularPostos() {
      this.showModalFeriado = false;
    },

    listarFeriadosEmpregador() {
      const th = this;
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_feriado: this.feriadoSelecionado.id,
      };

      this.axios
        .post("/api/feriado/listarFeriadoEmpregador", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.postosFeriado = response.data.data.dados;
        })
        .catch((err) => {
          th.postos = [];
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar vinculos!",
            "error",
          );
        });
    },

    listarPostos() {
      const th = this;
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
      };

      this.axios
        .post("/api/empregador/listarTodosEmpregadores2", bodyFormData)
        .then((response) => {
          th.postos = response.data.data.dados;
        })
        .catch((err) => {
          th.postos = [];
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar postos de trabalho!",
            "error",
          );
        });
    },

    async vincularPostos(index, row) {
      this.showModalFeriado = true;
      this.feriadoSelecionado = row;
      this.postosFeriado = [];
      await this.listarFeriadosEmpregador();
    },

    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000,
      });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 2000,
          showConfirmButton: false,
        });
      }
    },

    moment: function(data) {
      return moment(data);
    },

    listarFeriados() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/feriado/listarFeriado", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.data.dados.length > 0) {
            th.tableData = response.data.data.dados.map((e) => {
              e.data1 = moment(e.data).format("YYYY-MM-DD");
              e.data = moment(e.data).format("DD/MM/YYYY");
              return e;
            });
          } else {
            th.tableData = [];
          }
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar feriados!",
            "error",
          );
        });
    },

    limparForm() {
      this.modal.descricao = "";
      this.modal.dataFeriado = "";
    },

    abrirModal(edicao, data) {
      this.limparForm();
      if (edicao) {
        this.idFuncionarioSelecionado = data.id;
        this.modal.descricao = data.descricao;
        this.modal.dataFeriado = data.data1;
        this.dialogHorarioLimite = true;
        this.cadAlt = "Alterar";
      } else {
        this.cadAlt = "Cadastrar";
        this.dialogHorarioLimite = true;
      }
    },

    salvarFeriado() {
      if (this.cadAlt == "Alterar") {
        this.handleEdit();
        return;
      }
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        descricao: this.modal.descricao,
        data: this.modal.dataFeriado,
        empregadores: this.postos.map((p) => p.id),
      };
      this.axios
        .post("/api/feriado/cadatrarFeriado", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.dialogHorarioLimite = false;
          th.listarFeriados();
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Feriado cadastrado com sucesso!",
            "success",
          );
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao cadastrar feriado!",
            "error",
          );
        });
    },

    handleEdit() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        descricao: this.modal.descricao,
        data: this.modal.dataFeriado,
        id: this.idFuncionarioSelecionado,
      };
      this.axios
        .post("/api/feriado/atualizarFeriado", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.dialogHorarioLimite = false;
          th.idFuncionarioSelecionado = 0;
          th.listarFeriados();
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Feriado cadastrado com sucesso!",
            "success",
          );
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao cadastrar feriado!",
            "error",
          );
        });
    },

    handleDelete(index, row) {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: row.id,
      };
      this.axios
        .post("/api/feriado/deletarFeriado", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;

          th.showSwal(
            "auto-close",
            "Sucesso",
            "Feriado excluido com sucesso!",
            "success",
          );

          th.listarFeriados();
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao deletar feriado!",
            "error",
          );
        });
    },
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
